import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=edadcdb2&scoped=true&"
import script from "./Tip.vue?vue&type=script&lang=ts&"
export * from "./Tip.vue?vue&type=script&lang=ts&"
import style0 from "./Tip.vue?vue&type=style&index=0&id=edadcdb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edadcdb2",
  null
  
)

export default component.exports